export const  config = {
  pagination: false,
  rowSelection: false,
  fieldControl: false,
  tableType: 'antd',
  columns: [
    {
      title: "分类名称",
      dataIndex: "label",
      width: 200,
      ellipsis: true,
    },
    {
      title: "创建人",
      dataIndex: ['object','createdBy'],
      width: 120,
      ellipsis: true,
    },
    {
      title: "创建时间",
      dataIndex: ['object','createdTime'],
      width: 120,
      ellipsis: true,
      itemType: 'dateTime'
    },
    {
      title: '状态',
      dataIndex: ['object','status'],
      width: 90,
      fixed: "right",
      render: 'switchRender',
    },
    {
      title: "操作",
      dataIndex: "action",
      fixed: "right",
      width: 200,
      render: "operationFn",
    },
  ],
  search: [],
  footer: [
    {
      label: "新建",
      type: "primary",
      auth: '',
      events: ["onClick:onAddOrEdit"]
    }
  ],
}